"use client";

import { skillBadges } from "@/components/command-skills/skill-utils";
import type { SkillListItem } from "@/types/command-skill";
import { cn } from "@/lib/utils";

export function SkillBadges({
  skill,
  isSuperAdmin,
  className,
}: {
  skill: SkillListItem;
  isSuperAdmin: boolean;
  className?: string;
}) {
  const badges = skillBadges(skill, isSuperAdmin);
  if (badges.length === 0) return null;
  return (
    <span className={cn("inline-flex min-w-0 flex-wrap items-center gap-x-2 text-xs text-muted-foreground", className)}>
      {badges.map((badge) => (
        <span key={badge.key} className="truncate">
          {badge.label}
        </span>
      ))}
    </span>
  );
}
